class HaggardStock extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.message = this.querySelector('.product-low-stock--message');
    this.translations = JSON.parse(this.querySelector('script').textContent);
    this.update({available: this.dataset.initialAvailability === 'true', inventory_quantity: Number(this.dataset.initialQuantity), inventory_management: this.dataset.initialManagement, inventory_policy: this.dataset.initialPolicy, title: this.dataset.initialTitle});
    window.addEventListener(`theme:product:${this.dataset.id}:variantChanged`, event => this.update(event.detail.variant), {signal: this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
  update(variant) {
    const count = Number(variant.inventory_quantity);
    const threshold = Number(this.dataset.threshold);
    const visible = variant.available && variant.inventory_management && variant.inventory_policy !== 'continue' && count > 0 && count <= threshold;
    this.parentElement.setAttribute('aria-hidden', String(!visible));
    if (!visible) { this.message.textContent = ''; return; }
    const title = variant.public_title || variant.title || '';
    const template = title && title !== 'Default Title' ? this.translations.variant : this.translations.single;
    this.message.textContent = template.replace('[count]', count).replace('[variant]', title);
    this.style.setProperty('--progress-percent', `${100 * count / threshold}%`);
  }
}
if (!customElements.get('haggard-stock')) customElements.define('haggard-stock', HaggardStock);

class HaggardCartAddon extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.button = this.querySelector('button');
    this.button.addEventListener('click', () => this.add(), {signal: this.controller.signal});
  }
  disconnectedCallback() { this.controller?.abort(); }
  async add() {
    if (this.button.disabled) return;
    const label = this.button.textContent;
    const view = this.closest('cart-element')?.dataset.view || 'drawer';
    const error = this.querySelector('[role="alert"]');
    error.hidden = true;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.button.textContent = this.button.dataset.adding;
    try {
      await customElements.whenDefined('cart-element');
      const Cart = customElements.get('cart-element');
      await Cart.addItems({method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: Number(this.dataset.variantId), quantity: 1}], sections: Cart.sections})});
      const checkout = document.querySelector(`cart-element[data-view="${view}"] .cart--button`);
      checkout?.focus({preventScroll: true});
    } catch {
      error.hidden = false;
      this.button.disabled = false;
      this.button.setAttribute('aria-busy', 'false');
      this.button.textContent = label;
    }
  }
}
if (!customElements.get('haggard-cart-addon')) customElements.define('haggard-cart-addon', HaggardCartAddon);
